<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showMarketingCode") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- <base-image-upload-input
            col="12"
            identifier="image"
            :placeholder="$t('PLACEHOLDERS.countery_image')"
            @selectImage="selectImage"
          /> -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Password Input -->
          <!-- <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            disabled
          /> -->
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <!-- <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            disabled
          /> -->
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Client_booking_commission Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.client_booking_commission')"
            v-model.trim="data.client_booking_commission"
            disabled
          />
          <!-- End:: Client_booking_commission Input -->

          <!-- Start:: Provider_registration_commission Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.provider_registration_commission')"
            v-model.trim="data.provider_registration_commission"
            disabled
          />
          <!-- End:: Provider_registration_commission Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <!-- <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div> -->
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EditCountry",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        name: null,
        email: null,
        password: null,
        passwordConfirmation: null,
        client_booking_commission: null,
        provider_registration_commission: null,
        active: true,
      },

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      // // Start:: Append Request Data

      REQUEST_DATA.append("name", this.data.name);
      REQUEST_DATA.append("email", this.data.email);
      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }
      if (this.data.passwordConfirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.passwordConfirmation
        );
      }
      REQUEST_DATA.append(
        "client_booking_commission",
        this.data.client_booking_commission
      );
      REQUEST_DATA.append(
        "provider_registration_commission",
        this.data.provider_registration_commission
      );

      REQUEST_DATA.append("is_active", +this.data.active);
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `marketing-codes/${this.$route.params?.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/marketing-codes/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `marketing-codes/${this.$route.params?.id}`,
        });
        console.log("code ", res);

        this.data.name = res.data.data.MarketingCode.name;
        this.data.email = res.data.data.MarketingCode.email;
        this.data.password = res.data.data.MarketingCode.password;
        this.data.passwordConfirmation =
          res.data.data.MarketingCode.passwordConfirmation;
        this.data.client_booking_commission =
          res.data.data.MarketingCode.client_booking_commission;
        this.data.provider_registration_commission =
          res.data.data.MarketingCode.provider_registration_commission;

        this.data.created_at = res.data.data.MarketingCode.created_at;
        this.data.active = res.data.data.MarketingCode.is_active;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showData();
  },
};
</script>
